import React, { useState, useEffect } from 'react';
import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';
import './SignageMediaLibrary.css';
import DropdownMenu from '../../../components/SignagePlus/DropdownMenu';
import { FormattedMessage, useIntl } from "react-intl";
import API from '../../../utils/API';

const FolderTree = ({ folderTreeData, checkedKey, setCheckedKey, selectedKey, setSelectedKey, handleDeleteFolder, triggerEditFolder, setError }) => {

    const [editingKey, setEditingKey] = useState(null);
    const [editingValue, setEditingValue] = useState('');
    const [lastSelectedKey, setLastSelectedKey] = useState(null);
    const [treeData, setTreeData] = useState([]);  
    const intl = useIntl();
    const t = (id) => intl.formatMessage({ id });

    const handleEdit = (key, title) => {
        if (selectedKey.includes(key)) {
            setEditingKey(key);
            setEditingValue(title);
        } else {
            setSelectedKey([key]);
        }
    };

    useEffect(() => {
        setTreeData(folderTreeData);
    }, [folderTreeData]);

    const resetEditingState = () => {
        setEditingKey(null);
        setEditingValue('');
    };

    const handleSave = async (key) => {
        if (editingValue.trim().length < 2 || editingValue.trim().length > 36) {
            resetEditingState();
            setError(<FormattedMessage id='FOLDER_NAME_LENGTH' />);
            return;
        }

        const originalTitle = treeData.find(item => item.key === key).title;
        if (editingValue === originalTitle) {
            resetEditingState();
            return;
        }

        try {
             const mediaData = {
                data:{
                /*category: constants.SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA,
                subcategory: constants.SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.FOLDER,
                type: constants.SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.FOLDER,
                parentId: null,*/
                name: editingValue.trim(),
                //cmsId: selectedSiteCmsIds.length > 0 ? selectedSiteCmsIds[0] : null,
                //siteId: selectedSiteIds.length > 0 ? selectedSiteIds[0] : null
                }
            };
            let res = await API.updateMediaFolder(key, mediaData);
            const updateTreeData = (data) =>
                data.map(item => item.key === key ? { ...item, title: editingValue.trim() } : item);
            setTreeData(updateTreeData(treeData));
        } catch (err) {
            let message = err?.response?.data?.message;
            message = message? t(message) : err.message;
            setError(<FormattedMessage id='EDIT_FOLDER_FAILED' values={{ errorMsg: <b>{message}</b> }} />);
        } finally {
            resetEditingState();
        }
    }

    const handleCheck = (keys, { node, nativeEvent }) => {
        nativeEvent.stopPropagation();
        if (nativeEvent.ctrlKey) {
            setCheckedKey((prevCheckedKey) => {
                if (prevCheckedKey.includes(node.key)) {
                    return prevCheckedKey.filter((key) => key !== node.key);
                } else {
                    return [...prevCheckedKey, node.key];
                }
            });
        } else if (nativeEvent.shiftKey && lastSelectedKey) {
            const startIndex = treeData.findIndex(item => item.key === lastSelectedKey);
            const endIndex = treeData.findIndex(item => item.key === node.key);
            const range = [startIndex, endIndex].sort((a, b) => a - b);
            const newKeys = treeData.slice(range[0], range[1] + 1).map(item => item.key);
            setCheckedKey([...new Set([...keys, ...newKeys])]);
        } else {
            setCheckedKey(keys);
        }
        setLastSelectedKey(node.key);
    };

    const handleBlur = (key) => {
        handleSave(key);
    };

    const handleClickOutside = (event) => {
        if (editingKey && !event.target.closest('.editing-input')) {
            handleSave(editingKey);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [editingKey, editingValue]);

    const handleSelect = (selectedKeys, { node, nativeEvent }) => {
        if (selectedKey === '-1') {
            setSelectedKey([node.key]);
            setLastSelectedKey(node.key);
            return;
        }
        if (nativeEvent.ctrlKey) {
            setSelectedKey((prevSelectedKeys) => {
                if (selectedKey.includes(node.key)) {
                    return prevSelectedKeys.filter((key) => key !== node.key);
                }
                return [...prevSelectedKeys, node.key];
            });
        } else if (nativeEvent.shiftKey && lastSelectedKey) {
            const startIndex = treeData.findIndex(item => item.key === lastSelectedKey);
            const endIndex = treeData.findIndex(item => item.key === node.key);
            const range = [startIndex, endIndex].sort((a, b) => a - b);
            const newSelectedTextKeys = treeData.slice(range[0], range[1] + 1).map(item => item.key);
            setSelectedKey([...new Set([...selectedKey, ...newSelectedTextKeys])]);
        } else {
            setSelectedKey([node.key]);
        }
        setLastSelectedKey(node.key);
    };

    const handleDelete = async (e, key) => {
        e.stopPropagation();
        await handleDeleteFolder(key);
    };

    const renderTreeNodes = (data) =>
        Array.isArray(data) ? data.map((item) => {
            const isSelected = selectedKey.includes(item.key);
            const nodeClassName = isSelected ? 'selected-node' : '';
            const treeNodeClassName = isSelected ? 'rc-tree-treenode-selected' : '';

            if (item.key === editingKey) {
                return {
                    title: (
                        <input
                            className="editing-input"
                            value={editingValue}
                            onChange={(e) => setEditingValue(e.target.value)}
                            onBlur={() => handleBlur(item.key)}
                        />
                    ),
                    key: item.key,
                    dataRef: item,
                    className: treeNodeClassName,
                };
            }
            return {
                title: (
                    <div className={`node-content ${nodeClassName}`} title={item.title} style={{ paddingRight: '20px' }}>
                        <span
                            onClick={(e) => {
                                if (!e.ctrlKey && !e.metaKey) {
                                    handleEdit(item.key, item.title);
                                }
                                handleSelect([item.key], { node: item, nativeEvent: e });
                            }}							
                            style={{whiteSpace: 'pre', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                            {item.title}
                        </span>
                        <DropdownMenu                         
                          options={[
                            {
                            key: 'edit',
                            label: 'EDIT_FOLDER',
                            databstoggle: "modal",
                            databstarget: "#folderModal",
                            onClick: e => {

                                e.preventDefault();
                                triggerEditFolder(item.key);
                            }
                            },
                            {
                            key: 'remove',
                            label: 'REMOVE',
                            onClick: e => { e.preventDefault(); handleDelete(e, item.key) }
                            }
                        ]} />
                    </div>
                ),
                key: item.key,
                dataRef: item,
                checkable: true,
                switcherIcon: null,
                className: treeNodeClassName,
            };
        }) : [];

    return (
        <>
            <div className="link-container all-Files-div" >
                <span
                    className={`text-decoration-none cursor-pointer all-Files-option ${selectedKey === '-1' ? 'selected-option' : ''}`}
                    onClick={(e) => setSelectedKey('-1')}
                >
                    <FormattedMessage id="ALL_FILES" defaultMessage="All Files" />
                </span>
            </div>
            <div className='scrollable-div' style={{ flexGrow: '1'}}>
                <Tree
                    checkable
                    onCheck={handleCheck}
                    checkedKeys={checkedKey}
                    onSelect={handleSelect}
                    selectedKeys={selectedKey === '-1' ? [] : selectedKey}
                    showIcon={false}
                    treeData={renderTreeNodes(treeData)}
                />
            </div>
        </>
    );
};

export default FolderTree;
